// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__fWnM6","item":"Breadcrumbs_item__5RgS-","link":"Breadcrumbs_link__kgrHI"};